type PdfRendererProps = {
  url: string
  name: string
}
export const PdfPreviewRenderer = ({ name, url }: PdfRendererProps) => (
  <iframe className="!w-full !h-full !m-0" title={name} src={url} />
)
